import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-scroll--left",
  "use": "icon-scroll--left-usage",
  "viewBox": "0 0 17 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 25\" id=\"icon-scroll--left\"><path d=\"M4.503 11.089c-.83-.77-2.175-.77-3.005 0a1.893 1.893 0 0 0-.623 1.393c0 .505.208 1.009.623 1.394l11.335 10.511c2.004 1.858 5.01-.929 3.006-2.787L4.503 11.089v2.787L15.84 3.365c.83-.77.83-2.018 0-2.788s-2.176-.77-3.006 0L1.498 11.09a1.893 1.893 0 0 0-.623 1.393c0 .505.208 1.009.623 1.394l11.335 10.511L15.84 21.6 4.503 11.089Z\" fill=\"#002D72\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol